import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { useSite } from "@/context/SiteContext";

const PATH_TO_KEY = {
  "/": "home",
  "/products": "products",
  "/artists": "artists",
  "/dealers": "dealers",
  "/about": "about",
  "/contact": "contact",
};

export default function Seo() {
  const site = useSite();
  const { pathname } = useLocation();
  const seo = site.seo || {};

  // exact match, else first path segment (e.g. /products/:id -> products)
  let key = PATH_TO_KEY[pathname];
  if (!key) {
    const seg = "/" + (pathname.split("/")[1] || "");
    key = PATH_TO_KEY[seg];
  }
  const meta = (key && seo[key]) || seo.home || {};

  const title = meta.title || "GAVRA Hardware";
  const description = meta.description || "";
  const ogTitle = meta.og_title || title;
  const ogDescription = meta.og_description || description;
  const rawImage = meta.og_image || "";
  const ogImage = /^https?:\/\//i.test(rawImage) || rawImage.startsWith("/") ? rawImage : "";

  return (
    <Helmet>
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={ogTitle} />
      {ogDescription && <meta property="og:description" content={ogDescription} />}
      {ogImage && <meta property="og:image" content={ogImage} />}
      <meta name="twitter:card" content={ogImage ? "summary_large_image" : "summary"} />
      <meta name="twitter:title" content={ogTitle} />
      {ogDescription && <meta name="twitter:description" content={ogDescription} />}
      {ogImage && <meta name="twitter:image" content={ogImage} />}
    </Helmet>
  );
}
